const getters = {
  isLogined: state => state.main.logined,
  userInfo: state => state.main.user_info,
  mobile_verificat_time: state => state.main.mobile_verificat_time,
  mobile_verificat_timer: state => state.main.mobile_verificat_timer
}

export default getters
